// extracted by mini-css-extract-plugin
export var banner = "unmistabakly-module--banner--2dnk8";
export var fontSize = "unmistabakly-module--fontSize--vjKqp";
export var paragraphText = "unmistabakly-module--paragraphText--6-pQZ";